!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.fo = a());
}(this, function () {
  "use strict";

  return [{
    locale: "fo",
    pluralRuleFunction: function (e, a) {
      return a ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ár",
        relative: {
          0: "í ár",
          1: "næsta ár",
          "-1": "í fjør"
        },
        relativeTime: {
          future: {
            one: "um {0} ár",
            other: "um {0} ár"
          },
          past: {
            one: "{0} ár síðan",
            other: "{0} ár síðan"
          }
        }
      },
      "year-short": {
        displayName: "ár",
        relative: {
          0: "í ár",
          1: "næsta ár",
          "-1": "í fjør"
        },
        relativeTime: {
          future: {
            one: "um {0} ár",
            other: "um {0} ár"
          },
          past: {
            one: "{0} ár síðan",
            other: "{0} ár síðan"
          }
        }
      },
      month: {
        displayName: "mánaður",
        relative: {
          0: "henda mánaðin",
          1: "næsta mánað",
          "-1": "seinasta mánað"
        },
        relativeTime: {
          future: {
            one: "um {0} mánað",
            other: "um {0} mánaðir"
          },
          past: {
            one: "{0} mánað síðan",
            other: "{0} mánaðir síðan"
          }
        }
      },
      "month-short": {
        displayName: "mnð.",
        relative: {
          0: "henda mánaðin",
          1: "næsta mánað",
          "-1": "seinasta mánað"
        },
        relativeTime: {
          future: {
            one: "um {0} mnð.",
            other: "um {0} mnð."
          },
          past: {
            one: "{0} mnð. síðan",
            other: "{0} mnð. síðan"
          }
        }
      },
      day: {
        displayName: "dagur",
        relative: {
          0: "í dag",
          1: "í morgin",
          2: "í ovurmorgin",
          "-2": "fyrradagin",
          "-1": "í gjár"
        },
        relativeTime: {
          future: {
            one: "um {0} dag",
            other: "um {0} dagar"
          },
          past: {
            one: "{0} dagur síðan",
            other: "{0} dagar síðan"
          }
        }
      },
      "day-short": {
        displayName: "da.",
        relative: {
          0: "í dag",
          1: "í morgin",
          2: "í ovurmorgin",
          "-2": "fyrradagin",
          "-1": "í gjár"
        },
        relativeTime: {
          future: {
            one: "um {0} da.",
            other: "um {0} da."
          },
          past: {
            one: "{0} da. síðan",
            other: "{0} da. síðan"
          }
        }
      },
      hour: {
        displayName: "tími",
        relative: {
          0: "hendan tíman"
        },
        relativeTime: {
          future: {
            one: "um {0} tíma",
            other: "um {0} tímar"
          },
          past: {
            one: "{0} tími síðan",
            other: "{0} tímar síðan"
          }
        }
      },
      "hour-short": {
        displayName: "t.",
        relative: {
          0: "hendan tíman"
        },
        relativeTime: {
          future: {
            one: "um {0} t.",
            other: "um {0} t."
          },
          past: {
            one: "{0} t. síðan",
            other: "{0} t. síðan"
          }
        }
      },
      minute: {
        displayName: "minuttur",
        relative: {
          0: "hendan minuttin"
        },
        relativeTime: {
          future: {
            one: "um {0} minutt",
            other: "um {0} minuttir"
          },
          past: {
            one: "{0} minutt síðan",
            other: "{0} minuttir síðan"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "hendan minuttin"
        },
        relativeTime: {
          future: {
            one: "um {0} min.",
            other: "um {0} min."
          },
          past: {
            one: "{0} min. síðan",
            other: "{0} min. síðan"
          }
        }
      },
      second: {
        displayName: "sekund",
        relative: {
          0: "nú"
        },
        relativeTime: {
          future: {
            one: "um {0} sekund",
            other: "um {0} sekund"
          },
          past: {
            one: "{0} sekund síðan",
            other: "{0} sekund síðan"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "nú"
        },
        relativeTime: {
          future: {
            one: "um {0} sek.",
            other: "um {0} sek."
          },
          past: {
            one: "{0} sek. síðan",
            other: "{0} sek. síðan"
          }
        }
      }
    }
  }, {
    locale: "fo-DK",
    parentLocale: "fo"
  }];
});